import firebase from 'firebase'

const firebaseConfig = {
  apiKey: 'AIzaSyBoQ__KiYcr97SfVAM6TRcTfSb395nzUEk',
  authDomain: 'md-az-clone.firebaseapp.com',
  databaseURL: 'https://md-az-clone.firebaseio.com',
  projectId: 'md-az-clone',
  storageBucket: 'md-az-clone.appspot.com',
  messagingSenderId: '500769000061',
  appId: '1:500769000061:web:e6e938b52fc6d0d32d7f14',
  measurementId: 'G-Z0CW6391PG'
}

const firebaseApp = firebase.initializeApp(firebaseConfig)

const db = firebaseApp.firestore()
const auth = firebase.auth()

export { db, auth }
